/**
 * Tips shown at the bottom of the matchmaking screen (PHASE3 T3.2): our own wording (D-048),
 * each true for the game as merged (M-001 … M-007, items D-022), at most 80 characters. A ride
 * tip ("Crystal shards charge your ride.") joins the list when rides exist (T3.10 / T3.11).
 */
export const TIPS: readonly string[] = [
  'Double jump: press jump again while you are in the air.',
  'Upper routes are faster, but a fall costs you time.',
  'Item boxes give stronger items to racers at the back.',
  'Hold jump for a high leap; tap it for a short hop.',
  'A Shield Bubble takes one hit for you.',
  'Jump at the last moment to dodge a Homing Drone.',
  'Slow strips sap your speed. A Boost Jet runs straight over them.',
  'You carry one item at a time: use it before the next box.',
  'Trapdoors rattle before their stakes pop up. Time your jump!',
  'Play with friends: share your room code and race together.',
]

/** How long each tip stays up. */
export const TIP_MS = 5000

/** The tip index `ms` into the rotation (pure: the screen passes the time since it opened). */
export function tipAt(ms: number): number {
  const step = Math.floor(Math.max(0, ms) / TIP_MS)
  return step % TIPS.length
}
